var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({attrs:{"title":_vm.formType === 'login' ? 'Login with LinkedIn' : 'Sign up with LinkedIn'}},_vm.formType === 'login' ? { click: _vm.linkedinLogin } : { click: _vm.socialSignUp }),[_c('LinkedinIcon'),_vm._v(" "),_c('span',[_vm._v("\n    LinkedIn\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }